import request from './../../utilities/request';

function generate(values) {
  return request({
    url:    '/p/lead/generate',
    method: 'POST',
    data:   values
  });
}

const LeadService = {
  generate
}

export default LeadService;
